export default class Fornecedor {
  constructor(
    id = 0,
    codPessoa = 0,
    ativo = 1,
    cnpj = "",
    codEndereco = 0,
    cpf = "",
    email = "",
    nome = "",
    rg = "",
    telefone1 = "",
    telefone2 = "",
    bairro = "",
    cep = "",
    cidade = "",
    estado = "",
    logradouro = "",
    numero = ""
  ) {
    this.id = id
    this.codPessoa = codPessoa
    this.ativo = ativo
    this.cnpj = cnpj
    this.codEndereco = codEndereco
    this.cpf = cpf
    //this.dataNasc = dataNasc
    this.email = email
    this.nome = nome
    this.rg = rg
    this.telefone1 = telefone1
    this.telefone2 = telefone2
    this.bairro = bairro
    this.cep = cep
    this.cidade = cidade
    this.estado = estado
    this.logradouro = logradouro
    this.numero = numero
  }
}
